import { get } from 'api/client';
import type { Account } from 'types/Account';

export const requestUserAccountData = (): Promise<Account> => {
  return get('/api/ajaxGetUserAccountData');
};
